import React from "react";
import { useSelector } from "react-redux";
import Split from "react-split";
import "./Splitter.css";

const Splitter = ({ children }) => {
  const viewer = useSelector((state) => state.viewer);

  // Fit BPMN diagram to viewport
  const fitViewer = async () => {
    if (viewer?.get("canvas")) {
      viewer.get("canvas").zoom("fit-viewport");
    }
  };

  return (
    <Split
      className="splitter-main p-4 d-flex"
      sizes={[30, 70]}
      minSize={300}
      expandToMin={false}
      gutterSize={10}
      gutterAlign="center"
      snapOffset={30}
      dragInterval={1}
      direction="horizontal"
      cursor="col-resize"
      onDragEnd={fitViewer}
    >
      {children}
    </Split>
  );
};

export default Splitter;
